import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="w-full bg-white" data-id="element-42" data-mp="1lb90yxa19gj2">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-43" data-mp="1l9frla81ci7d">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-44" data-mp="1geikw9y8akxn">
          <h2 id="faq-heading" className="text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-45" data-mp="2dzxuaa4ukhk9">
            Common questions
          </h2>

          <dl className="divide-y divide-kosin-line border-y border-kosin-line" data-id="element-46" data-mp="240yxppxcwcdm">
            {faqs.map((faq, i) => {
            const isOpen = open === i;
            return <div key={faq.question} data-id="element-47" data-mp="so6409l09dux" data-mpi={i}>
                  <dt data-id="element-48" data-mp="sl0g2xo44i0s">
                    <button type="button" className="flex w-full items-start justify-between gap-6 py-5 text-left" aria-expanded={isOpen} aria-controls={`faq-answer-${i}`} onClick={() => setOpen(isOpen ? null : i)} data-id="element-49" data-mp="noa1keryhuhh">
                      <span className="text-[18px] font-semibold text-kosin-charcoal" data-id="element-50" data-mp="fj8inp0ycdcl">
                        {faq.question}
                      </span>
                      {isOpen ? <MinusIcon className="mt-1 h-5 w-5 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-51" data-mp="6qofqcdmnmly" /> : <PlusIcon className="mt-1 h-5 w-5 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-52" data-mp="3t07t250oji4r" />}
                    </button>
                  </dt>
                  <dd id={`faq-answer-${i}`} hidden={!isOpen} className="pb-6 pr-10 text-[16px] leading-relaxed text-kosin-body" data-id="element-53" data-mp="3nzbqbus2e20x">
                    {faq.answer}
                  </dd>
                </div>;
          })}
          </dl>
        </div>
      </div>
    </section>;
}